import React from "react";
import content from "../content/content.json";

const Hero = ({ onScrollClick }) => {
  const { hero, shared, tradeSection } = content;

  return (
    <section className="relative w-full h-screen overflow-hidden flex flex-col md:flex-row">
      <div className="w-full md:w-1/2 bg-[#0f1016] text-white px-8 md:px-16 py-12 flex flex-col justify-center">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-extrabold leading-tight">{hero.heading}</h1>
        {hero.supporting && <p className="mt-3 text-gray-300 text-lg max-w-xl">{hero.supporting}</p>}
        <button className="mt-6 bg-red-600 hover:bg-red-700 transition px-6 py-3 text-white font-semibold rounded-sm w-fit">
          {hero.learnMore} {shared.arrow}
        </button>
      </div>

      <div className="w-full md:w-1/2 flex flex-col md:flex-row h-full">
        <div className="w-full md:w-1/2 bg-[#1c1f2b] text-white px-8 py-12 flex flex-col justify-center space-y-4">
          <p className="uppercase text-sm text-gray-400">{hero.quickLinksTitle}</p>
          {hero.quickLinks.map((link, index) => (
            <a key={link} href={hero.href[index]} className="font-semibold hover:underline">
              {link} {shared.arrow}
            </a>
          ))}
        </div>

        <div
          className="w-full md:w-1/2 bg-cover bg-center relative"
          style={{
            backgroundImage: `url('${hero.backgroundImage}')`,
          }}
        >
          <div className="hidden md:flex absolute bottom-8 left-1/2 -translate-x-1/2 flex-col items-center gap-2">
            <span className="text-xs text-white/60 uppercase tracking-widest">{hero.scroll}</span>
            <div className="w-[1px] h-10 bg-white/30 relative overflow-hidden">
              <div className="absolute top-0 left-0 w-full bg-white animate-[scrollLine_1.5s_ease-in-out_infinite]" style={{ height: "40%", animation: "scrollLine 1.5s ease-in-out infinite" }} />
            </div>
            <span className="text-white/60 text-lg">↓</span>
          </div>
        </div>
      </div>

      {onScrollClick && (
        <button
          type="button"
          onClick={onScrollClick}
          className="absolute z-20 bottom-24 right-6 bg-white text-gray-800 text-sm font-semibold tracking-wider px-6 py-3 shadow-md rounded-sm flex items-center gap-2 hover:bg-gray-100 transition-colors"
        >
          {tradeSection.skip} <span className="text-lg">{shared.downArrow}</span>
        </button>
      )}
    </section>
  );
};

export default Hero;

